"use strict";

exports.__esModule = true;
exports.ConditionRuleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ConditionRuleContainer = exports.ConditionRuleContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ConditionRuleContainer",
  componentId: "sc-ie65pu-0"
})(["display:flex;flex-direction:row;justify-content:space-between;.bp6-popover-wrapper,.bp6-popover-target{height:100%;}.bp6-button.bp6-small,.bp6-small .bp6-button{padding:0px;}& > *{margin:0px 2.5px;}"]);